import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const ChirstmasGifts = () => {
    const CTAContent = [
        {
          pageName: "Christmas Gifts",
          paragraphitalic: "Add a Dash of Holiday Cheer",
          paragraphText:
                "Spread the joy of the festive season with Christmas gifts that embody warmth and celebration. From cozy hampers to delightful chocolates, our Christmas collection is perfect for making spirits bright.",
          ContactFormName: "Christmas Gifts",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Holiday Hampers",
          parapgraphItalic: "Packed with Cheer, Delivered with Love",
          sectionparagraphText: (
            <>
              <p>
                Holiday hampers that bring smiles and spread festive magic
              </p>
              <p>
                What’s Christmas without a little indulgence? Our holiday hampers are a treasure trove of festive delights, curated to bring joy to every recipient. Overflowing with seasonal treats and premium goodies, these hampers are perfect for clients, employees, or anyone on your “nice” list! 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/chirstmas-gifts/Holiday Hampers.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Premium Chocolates & Treats",
          parapgraphItalic: "Indulge in Sweet Festive Bliss",
          sectionparagraphText: (
            <>
              <p>
                Elevate the joy of Christmas with irresistible chocolates and treats. 
              </p>
              <p>
                Christmas is sweeter with chocolates! Our premium collection of festive treats is perfect for gifting—or enjoying yourself. From handcrafted truffles to exotic flavour pairings, these goodies are sure to satisfy every sweet tooth and add a dash of delight to the holidays. 
              </p>
            </>
          ),
        ImgSrc: "../assests/images/chirstmas-gifts/Premium Chocolates & Treat.jpg",
          categoryHeadingLeftSide: "Features That Tempt",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/chirstmas-gifts/Gourmet Chocolates.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Gourmet Chocolates</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/chirstmas-gifts/Festive Packaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Festive Packaging</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/chirstmas-gifts/Unique Flavour Profiles.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Unique Flavour Profiles</b> <br></br>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/chirstmas-gifts/Features That Delight.jpg",
          NogapHeading: "Features That Delight",
          Heading: [
            {
              ListHeading: "Seasonal Selections",
              ListParagraph:
                "Indulge in handpicked items like gourmet cookies, artisanal teas, and festive snacks.",
            },
            {
              ListHeading: "Customizable Goodness",
              ListParagraph:
                "Add a touch of personalization with branded packaging, messages, or unique themes.",
            },
            {
              ListHeading: "Elegant Presentation",
              ListParagraph:
                "Wrapped in festive hues with ribbons, tags, and eco-friendly packaging that wows.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/chirstmas-gifts/Customized Decor & Accessories.jpg",
          NogapHeading: "Customized Decor & Accessories",
          paragraphItalic: "Deck the Halls Your Way!",
          paragraphDetail: (
            <>
              <p>
                Add a personal touch to Christmas with customized décor and festive accessories.
              </p>
              <p>
                Make this Christmas truly yours with personalized décor and accessories. From engraved ornaments to custom stockings, our festive collection adds warmth and personality to every corner of your home or office. Perfect for spreading the holiday spirit in style! 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Sparkle",
          Categories: [
            {
              ServiceImg: "../assests/images/chirstmas-gifts/Personalized Ornaments.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Ornaments</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/chirstmas-gifts/Festive Accessories.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Festive Accessories</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/chirstmas-gifts/Creative Themes.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Creative Themes</b>
                  </p>
                </>
              ),
            },
          ],
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>Appreciate dedication and achievements.</p>
              <p>
                Show appreciation for the hard work and dedication that goes into
                every achievement.
              </p>
              <p>
                Milestones such as work anniversaries, project completions, and
                promotions deserve to be celebrated. At eYantra, we provide a range
                of premium milestone gifts that are as unique as the achievements.
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/sub-pages/logo-printing.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/engraving.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/color-matching.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
      <title>  New Year Gifts</title>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Deliver gifts wrapped in festive magic and thoughtful touches that leave recipients feeling truly special
      </p>
    </>
  );
};

export default ChirstmasGifts;
